import angular from 'angular';

angular
  .module('cloudX')
  .factory('licensingSvc', ['$q', '$state', 'flySvc', '$http', 'appUrls', licensingSvc]);

function licensingSvc($q, $state, flySvc, $http, appUrls) {
  var licenseInformation = {};

  function showError(error) {
    flySvc.error(error.data.code, error.data.parameters);
  }

  function getLicenseInformation() {
    return licenseInformation;
  }

  function reloadLicenseInformation() {
    return $http.get(appUrls.api + '/api/license/Info').then(
      function(result) {
        if (result.data) licenseInformation = result.data;
        return licenseInformation;
      },
      function(error) {
        showError(error);
      },
    );
  }

  return {
    getLicenseInformation: getLicenseInformation,
    reloadLicenseInformation: reloadLicenseInformation,
  };
}
